import React from 'react'
import { CartIconContainer, ShoppingIconWrapper, CartIconCount } from './CartIconElements'
import { connect } from 'react-redux'
import { RiShoppingBasketLine } from 'react-icons/ri'
import { toggleCartHidden } from '../../redux/cart/cart.actions'
import { selectCartItemsCount } from '../../redux/cart/cart.selectors'
import { IconContext } from 'react-icons/lib'
import { createStructuredSelector } from 'reselect'

const CartIcon = ({ toggleCartHidden, itemCount }) => {
    return (
        <IconContext.Provider value={{ color: '#202020', size: '32px' }}>
            <CartIconContainer onClick={toggleCartHidden}>
                <ShoppingIconWrapper>
                    <RiShoppingBasketLine />
                    <CartIconCount>{itemCount}</CartIconCount>
                </ShoppingIconWrapper>
            </CartIconContainer>
        </IconContext.Provider>
    )
}

const mapDispatchToProps = dispatch => ({
    toggleCartHidden: () => dispatch(toggleCartHidden())
})

const mapStateToProps = createStructuredSelector({
    itemCount: selectCartItemsCount
})

export default connect(mapStateToProps, mapDispatchToProps)(CartIcon)
